import helpers from '../../util/helpers';

const searchBrands = () => {
  jQuery(document).ready(function($) {
    const page = $('html, body');

    // Brands Autocomplete
    const brandsSearch = $('input.brands-search');
    if (brandsSearch.length) {
      brandsSearch.each(function() {
        const _this = $(this);

        _this.rsdAutocomplete({
          minimumInputLength: -1,
          data: _this.data('feed') ? _this.data('feed') : [],
          layout: 1,
          showListName: false,
        });
      });

      brandsSearch.on('click', function() {
        if (helpers.isMobile()) {
          page.on('scroll mousewheel touchmove', function() {
            page.stop();
          });

          page.animate({scrollTop: $(this).offset().top}, 'slow', function() {
            page.off('scroll mousewheel touchmove');
          });
        }
      });

      brandsSearch.on('input', function() {
        const _this = $(this);

        if (_this.data('cookie-brand') && _this.val().length === 0) {
          helpers.docCookies.setItem(_this.data('cookie-brand'), _this.val(), 1500, '/');
        }
      }).on('input_changed.rsd-ac', function() {
        const _this = $(this);

        if (_this.data('cookie-brand')) {
          helpers.docCookies.setItem(_this.data('cookie-brand'), _this.val(), 1500, '/');
        }
      });
    }
  });
};

export default searchBrands;



// WEBPACK FOOTER //
// ./scripts/routes/modules/searchBrands.js